import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ConfirmEventType, ConfirmationService, MessageService } from 'primeng/api';
import { Subject, catchError, forkJoin, from, map, takeUntil } from 'rxjs';
import { AppMainService } from 'src/app/app-main.service';
import { SharedCRMConfigService } from 'src/app/configurations/crm/shared/services/shared-crm-config.service';
import { AccountModuleId, ContactModuleId, LeadModuleId } from 'src/app/modules/shared/constants/modules.constant';
import { TemplateSection } from 'src/app/modules/shared/model/templateSection.model';
import { AccountUserService } from 'src/app/service/account.service';
import { SharedContactV1Service } from '../../shared-contact-v1-Service';
import { GelAllAccountRequestModel } from 'src/app/accounts-v2/models/account-request.model';
import { AccountServiceN } from 'src/app/accounts-v2/services/account.services';
import { VENDOR_ID } from 'src/app/contacts/contacts.constant';
import { AppMainComponent } from 'src/app/app.main.component';
import { Contact } from '../../models/contactInterface.constant';
import { SharedDataService } from 'src/app/modules/shared/stores/sharedDataStore/sharedData.service';
import { CoreHttpService } from 'src/app/modules/shared/services/core.http.service';
import { Country } from '../../../shared-contacts/model/country';
import { AddressType } from 'src/app/accounts/model/addressType';
import { AddressClass } from 'src/app/accounts-v2/models/fields/addressClass.model';
import { ConfigurationService } from 'src/app/configurations/configurationService';
import { uploadFiles, validateFiles } from 'src/app/shared/upload-files';
import { Status } from 'src/app/models/statusEnums';
import { AddYearPipe } from 'src/app/shared/pipes/add-year.pipe';
import { FileUpload } from 'primeng/fileupload';
import { EMAIL_TYPE_IDS, PHONE_TYPE_IDS, SOCIAL_PROFILE_TYPE_IDS } from '../../../../constants/typeId';
import { ContactService } from 'src/app/contacts/contactService';
import { StoreService } from 'src/app/modules/shared/services/store.service';
import { PhoneNumberFormatService } from 'src/app/modules/shared/services/phone-number-format.service';
import { GelAllContactRequestModel } from 'src/app/contacts/model/contacts-request.model';
import { ColumnSettingsN } from 'src/app/modules/shared/models/column-settings.model';
import { ParseHelper } from 'src/app/modules/shared/parse.helper';
import { SharedColumnSettingsService } from 'src/app/modules/shared/services/column-settings.service';
import { LeadService } from 'src/app/leads/leadService';
import { AccountsHttpService } from 'src/app/modules/shared/services/accounts.http.service';

@Component({
  selector: 'app-add-edit-form',
  templateUrl: './add-edit-form.component.html',
  styleUrl: './add-edit-form.component.scss'
})
export class AddEditFormComponent implements OnInit, OnChanges, OnDestroy {
  contactForm: FormGroup;
  @Input() displayContactAddEdit: boolean = false;
  @Input() mainContactModule: boolean = false;
  @Input() selectedContact: any;
  @Input() selectedRecord : any;
  @Input() businessName: string = '';
  @Input() associationTypeName: string = '';
  @Input() contactModalHeader!: string;
  @Input() mode: 'view' | 'edit' | 'add' = 'add';
  generateSequenceSeriesNumber: string;
  @Input() selectedChannel;
  @Output() refreshList = new EventEmitter();
  @Output() displayContactAddEditChange = new EventEmitter<boolean>();
  @Output() loadContactList = new EventEmitter<boolean>();
  @ViewChild('fileInput') fileInput: FileUpload;//need to clear

  showMore: boolean = false;
  displayContact : boolean = false;
  showAddMore: boolean = false;
  isEditMode: boolean = false;
  updateStatusId: boolean = false;
  contactAssociations: any[] = [];
  countries: Country[] = [];
  contactTypes: any[] = [];
  titles: any[] = [];
  gender: any[] = [];
  langauge: any[] = [];
  jobFunction: any[] = [];
  contactRoles: any[] = [];
  relation: any[] = [];
  marital: any[] = [];
  source: any[] = [];
  annualIncome: any[] = [];
  degree: any[] = [];
  studyField: any[] = [];
  associationNames: any[];
  filteredBusinessNames: any = [];
  templateSections: TemplateSection[] = [];
  addressList: any[] = [];
  addressClasses: AddressClass[] = [];
  addressTypes: AddressType[] = [];
  contactProfileImages = [];
  phoneCountryCodes = [];
  contactTempAddress: any[] = [];
  reportsToList: any[] = [];
  assistantToList: any[] = [];
  seniorityList: any[] = [];
  labels_address = [];
  accountAddressTypes = [];
  transformedAddresses = [];
  LEAD_ID;
  ACCOUNT_ID;
  noTemplateMessage: string = "";
  seniority: string = "";
  inputDataCheck: any = {};
  countryData: any;
  selectedCountry: any = null;
  contactEditDetails: any;
  selectedContactDetails: any;
  defaultAddressType: AddressType;
  defaultAddressClass: AddressClass;
  contactModuleId = ContactModuleId;
  selectedModule = { id: ContactModuleId, name: 'Contact' };
  allowedExtensions = ['.png', '.jpg', '.jpeg', '.gif'];
  mainSelectedCountry: any = null;
  MAX_SIZE: number = 5 * 1024 * 1024;
  countryCode: any
  labels_addition: any;
  contactListAttn = [];
  private ngUnsubscribe$ = new Subject<void>();
  private ngUnsubscribe = new Subject<void>();
  phoneNumberFormat: string | null = null;
  selectedtitles :any ;
  currentSelectedIncome :any ;
  selectedContactType :any ;
  selectedDegree :any
  selectedStudyField :any ;
  selectedGender :any ;
  currentSelectedSource :any ;
  currentSelectedContactRole :any ;// for contact designation
  defaultContactRole :any; // for contact role
  isSubmitted :boolean = false ;
  availableIcons = [];
  // socialProfiles = ['fa-twitter']; 
  socialProfiles = []; 
  firstEmailLabel : string = "";
  firstPhoneLabel : string = "";
  availableFields: string[] = []; 
  availableEmailLabels: string[] = []; 
  displayManualPopup: boolean = false;
  manualRuleColumnSetttings: Partial<ColumnSettingsN> = {};
  selectedRecordList: any[] = [];
  selectedTemplate = {id:0};
  selectedParentAccount: any;
  allModuleList = [
    { id: AccountModuleId, name: 'Account' },
    { id: LeadModuleId, name: 'Lead' }
  ];
  accountData: any;
  isAssociationName: boolean = false;
  maxSelectableDate: Date = new Date(new Date().setDate(new Date().getDate()));
  constructor(private fb: FormBuilder,
    private messageService: MessageService,
    private appMainService: AppMainService,
    private sharedConfigService: SharedCRMConfigService,
    private accountUserService: AccountUserService,
    private sharedContactV1Service: SharedContactV1Service,
    private accountServiceN: AccountServiceN,
    private confirmationService: ConfirmationService,
    private app: AppMainComponent,
    private phoneNumberFormatService: PhoneNumberFormatService,
    private sharedDataService: SharedDataService,
    private coreHttpService: CoreHttpService,
    private storeService: StoreService,
    private contactService: ContactService,
    private columnSettingsService: SharedColumnSettingsService,
    private configurationService: ConfigurationService, 
    private addYearPipe: AddYearPipe,
    private leadService: LeadService,
    private accountsHttpService: AccountsHttpService,
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.getTemplateFormFields();
    this.setupFormListeners();
  }

 ngOnChanges(changes: SimpleChanges) :void {
    this.selectedTemplate.id = this.selectedChannel?.id ?? 1;
    if (changes.selectedContact && changes.selectedContact.currentValue) {
      this.selectedContactDetails = changes.selectedContact.currentValue;
    }
    if (changes?.associationTypeName && changes?.associationTypeName?.currentValue) {
      this.associationTypeName = changes?.associationTypeName?.currentValue?.toLowerCase();
    }
    this.getPhoneNumberTemplate();
    this.getCountryData();
    this.loadContactData(changes);
  }


  loadContactData(changes) {
    // this.appMainService.isShowSpinner('loadcompanyData');
    forkJoin({
      income: this.sharedContactV1Service.getAllAnnualIncome(),
      studyfield: this.sharedContactV1Service.getAllStudyField(),
      degree: this.sharedContactV1Service.getAllDegree(),
      contactsource: this.sharedContactV1Service.getAllContactSource(),
      marriedstatus: this.sharedContactV1Service.getAllMaritalStatus(),
      relationStatus: this.sharedContactV1Service.getAllRelationshipStatus(),
      role: this.sharedContactV1Service.getAllRoles(),
      language: this.sharedContactV1Service.getAllLanguage(),
      gender: this.sharedContactV1Service.getAllGender(),
      salutation: this.sharedContactV1Service.getSalutations(),
      contactTypes: this.sharedContactV1Service.getAllContactTypes(),
      association: this.sharedContactV1Service.getAllContactAssociation(),
      countryData: this.accountUserService.countryCode(),
      contactRoles : this.configurationService.getNewAllContactRoles()
    }).subscribe({
      next: ({ income, studyfield, degree, contactsource, marriedstatus, relationStatus, role, language,
        gender, salutation, contactTypes, association, countryData , contactRoles}) => {
        // this.appMainService.isHideSpinner('loadcompanyData');
        this.countryData = countryData;
        this.annualIncome = income;
        this.studyField = studyfield;
        this.degree = degree;
        this.source = contactsource;
        this.marital = marriedstatus;
        this.relation = relationStatus;
        this.jobFunction = role;
        this.contactRoles = contactRoles?.length ? contactRoles.map((role) => ({
          id: 0,
          roleId: role?.id,
          roleName: role?.name,
          isDefault: role?.isDefault,
        })) : [];
        this.langauge = language;
        this.gender = gender;
        this.contactAssociations = association;
        this.titles = salutation;
        

        this.getContactTypes(contactTypes);
        if (this.mode === 'add') {
          this.populateDefaultGroup();
        }
        this.initForm();
        this.storeService.setCountries(this.countries);
        if (this.selectedContactDetails) {
          this.populateContactEditDetails(this.selectedContactDetails);
        }
        if (this.selectedContact) {
          this.contactForm.patchValue(this.selectedContact);
        }
        if (changes?.displayContactAddEdit?.currentValue) {
          if(!this.displayContact){
            this.displayContact = changes.displayContactAddEdit.currentValue;
          }
        }
        if (changes.mode && changes.mode.currentValue) {
          if(this.mode == 'add'){
          this.generateSequenceNumber();
          }
        }
        if (changes.selectedRecord ?.currentValue && !this.mainContactModule && this.mode === 'add') {
          if (this.associationTypeName === 'account') {
            this.getAccountContacts(this.selectedRecord );
          } else if (this.associationTypeName === 'lead') {
            this.getLeadContacts(this.selectedRecord );
          }
        }else if (changes.mode?.currentValue && !this.mainContactModule && this.mode === 'add') {
          this.searchVendor(this.businessName);
        }
      },
    });
  }
  async getPhoneNumberTemplate() {
    this.phoneNumberFormat = await this.phoneNumberFormatService.getPhoneNumberFormat();
  }
  initForm(): void {
    const defaultAssociations = this.contactAssociations?.find(item => item.name == "Organization");
    this.contactForm = this.fb.group({
      contactType: [this.selectedContactType?.value || '', this.inputDataCheck.contactType?.isRequired ? Validators.required : null],
      contactAssociation: [this.contactAssociations?.find(title => title.name?.toLowerCase() === this.associationTypeName?.toLowerCase()) || defaultAssociations , this.inputDataCheck.contactAssociation?.isRequired ? Validators.required : null],
      businessName: ['', this.inputDataCheck.businessName?.isRequired ? Validators.required : null],
      selectedAssistant: ['',this.inputDataCheck.assistant?.isRequired ? Validators.required : null],
      selectedReportsTo: ['',this.inputDataCheck.report?.isRequired ? Validators.required : null],
      title: [this.selectedtitles?.id || this.titles?.find(title => title.name === "Mr")?.id || null,this.inputDataCheck.title?.isRequired ? Validators.required : null],
      firstName: ['', this.inputDataCheck.firstName?.isRequired ? Validators.required : null],
      middleName: ['',this.inputDataCheck.middleName?.isRequired ? Validators.required : null],
      lastName: ['',this.inputDataCheck.lastName?.isRequired ? Validators.required : null],
      country: [null],
      phoneNumber: ['',this.inputDataCheck.phoneNumber?.isRequired ? Validators.required : null],
      gender: [this.selectedGender || '',this.inputDataCheck.gender?.isRequired ? Validators.required : null],
      department: ['',this.inputDataCheck.department?.isRequired ? Validators.required : null],
      seniority: ['',this.inputDataCheck.seniority?.isRequired ? Validators.required : null],
      description: ['',this.inputDataCheck.description?.isRequired ? Validators.required : null],
      assistantPhone: [''],
      assPhoneCode: [this.app.userDetails?.locations?.[0]?.address?.country?.phoneCode || this.app.organizationData?.address?.country?.phoneCode],
      assCountry : [this.getCountryName(this.app.userDetails?.locations?.[0]?.address?.country?.name || this.app.organizationData?.address?.country?.name)],
      // if user select then add date
      birth: [null,this.inputDataCheck.birth?.isRequired ? Validators.required : null],
      language: [[],this.inputDataCheck.language?.isRequired ? Validators.required : null],
      startDate: [null,this.inputDataCheck.startDate?.isRequired ? Validators.required : null],
      jobFunction: [this.currentSelectedContactRole || '',this.inputDataCheck.jobFunction?.isRequired ? Validators.required : null],
      contactRoles: [this.defaultContactRole || '',this.inputDataCheck.contact_roles?.isRequired ? Validators.required : null],
      relation: ['',this.inputDataCheck.relation?.isRequired ? Validators.required : null],
      marital: ['',this.inputDataCheck.marital?.isRequired ? Validators.required : null],
      source: [this.currentSelectedSource || '',this.inputDataCheck.source?.isRequired ? Validators.required : null],
      income: [this.currentSelectedIncome || '',this.inputDataCheck.income?.isRequired ? Validators.required : null],
      degree: [this.selectedDegree || '',this.inputDataCheck.degree?.isRequired ? Validators.required : null],
      studyField: [this.selectedStudyField || '',this.inputDataCheck.studyField?.isRequired ? Validators.required : null],
      sequenceNumber: [''],
      contactProfileImages: [],
      additionalEmails: this.fb.array([this.createEmailField()]),
      additionalPhones: this.fb.array([this.createPhoneField()]),
      additionalSocialProfile: this.fb.array([this.createSocialField()]),
      contactAddresses: this.fb.array([]),
      isActive: [true]
    });
    this.contactForm.get('contactAssociation').disable();
  }
  getAccountContacts(account: any, contactName: any = "") {
    this.appMainService.isShowSpinner('getAccountDetailsById');
        this.accountsHttpService.getAccountDetails(account.id)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(resp => {
                this.accountData = resp;
                    this.contactForm.patchValue({
                      businessName: { id: this.accountData?.id, businessName: this.accountData?.businessName },
                    });
                    this.isAssociationName = true;
                    this.contactForm.get('contactAssociation').disable();
                this.appMainService.isHideSpinner('getAccountDetailsById');
            }, () => {
                this.appMainService.isHideSpinner('getAccountDetailsById');
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error!',
                    detail: 'Error occurring when fetching accounts details. Please try after sometimes.'
                });
            });
  }
  getLeadContacts(account: any, contactName: any = "") {
    this.appMainService.isShowSpinner('getLeadContacts');
    this.leadService.getLeadDetailsById(account.id).then(leadObj => {
      this.contactForm.patchValue({
        businessName: { id: leadObj?.id, businessName: leadObj?.businessName },
      });
      this.isAssociationName = true;
      this.contactForm.get('contactAssociation').disable();
      this.appMainService.isHideSpinner('getLeadContacts');
    }).catch((err) => {
      this.appMainService.isHideSpinner('getLeadContacts');
      this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error });
    });
  }
  checkEmailValidity(emailIndex: number) {
    const emailControl = this.additionalEmails.at(emailIndex).get('emailAddress');
    if (emailControl?.status === 'VALID'  && emailControl.value !='') {
      emailControl.markAsTouched();
      // this.contactEmailCheck(emailControl.value,emailIndex) // now allow if alredy used in contact
    } else {
      return
    }
  }
  contactEmailCheck(emailDetails: any,emailIndex) {
    setTimeout(() => {
     const associationId = this.contactAssociations?.find(item => item.name?.toLowerCase() == this.associationTypeName)?.id ;
     const contactId = this.contactEditDetails?.id ?? 0
      this.contactService
        .contactEmailValidation(
          emailDetails,
          associationId,
          contactId,
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe({
          next: (response) => {
            if (!response) {
              this.confirmationService.confirm({
                message: `${emailDetails} email already used in a contact, do you want to use it again?`,
                header: 'Email Already Used',
                icon: 'pi pi-exclamation-triangle',
                rejectLabel: 'Clear',
                acceptLabel: 'Yes',
                accept: () => {},
                reject: (type) => {
                  if (type == ConfirmEventType.REJECT){
                     this.additionalEmails.at(emailIndex).get('emailAddress').reset();
                  }
                },
              });
            }
          },
          error: (error) => {},
        });
    }, 300);
  }
  createPhoneField(name?: string): any {
    this.countryCode = this.app.userDetails?.locations?.[0]?.address?.country?.phoneCode || this.app.organizationData?.address?.country?.phoneCode
    return this.fb.group({
      country: [this.getCountryName(this.app.userDetails?.locations?.[0]?.address?.country?.name || this.app.organizationData?.address?.country?.name),[...this.getDynamicValidators('phone')]],
      number: ['',[...this.getDynamicValidators('phone')]],
      contactData: [null],
      name: [name || this.firstPhoneLabel],
      phoneCode :[this.app.userDetails?.locations?.[0]?.address?.country?.phoneCode || this.app.organizationData?.address?.country?.phoneCode]
    });
  }


  createEmailField(emailData?: any, label?: string): FormGroup {
    return this.fb.group({
      emailAddress: [emailData?.emailAddress || '', [...this.getDynamicValidators('email'),Validators.pattern("[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$") ]],
      label: [label || this.firstEmailLabel] 
    });
  }
  createSocialField(): FormGroup {
    return this.fb.group({
      socialProfile: ['',[...this.getDynamicValidators('social') ]]  ,
      profileData : [this.socialProfiles[0]] 
    });
  }

  getCountryName(countryName: string) {
    return this.countryData?.find(ele => ele.CountryName === countryName)
  }

  createSocialProfileField(socialProfile?,str?): FormGroup {
    return this.fb.group({
      socialProfile: [socialProfile?.socialProfile?.name?.length == 1 ? "" : socialProfile?.socialProfile?.name || '',[...this.getDynamicValidators('social') ]] ,
      profileData: [socialProfile || str]
    });
  }

  get additionalEmails(): FormArray {
    return this.contactForm.get('additionalEmails') as FormArray;
  }

  get additionalPhones() {
    return this.contactForm.get('additionalPhones') as FormArray;
  }

  get additionalSocialProfile() {
    return this.contactForm.get('additionalSocialProfile') as FormArray;
  }

  addEmailField(): void {
    const emailArray = this.contactForm.get('additionalEmails') as FormArray;
    if (emailArray?.length <= this.inputDataCheck?.email?.childFields?.length) { 
      const nextLabel = this.availableEmailLabels.shift(); 
      if (nextLabel) {
        const newEmailGroup = this.createEmailField(undefined, nextLabel);
        emailArray.push(newEmailGroup);
      }
    }
  }

  addPhoneField(): void {
    const additionalPhones = this.contactForm.get('additionalPhones') as FormArray;
    if (!additionalPhones?.length) {
      additionalPhones.push(this.createPhoneField(this.firstPhoneLabel));
      return; 
    }
    if (this.additionalPhones.length <= this.inputDataCheck?.phone?.childFields?.length ) {
      const nextLabel = this.availableFields.shift(); 
      additionalPhones.push(this.createPhoneField(nextLabel));
      this.phoneCountryCodes.push({ PhoneCode: '', number: '' });
    } 
  }
  
  saveParentAccount($event) {
      this.selectedRecordList = ParseHelper.DeepCopy($event.selectedReccords);
      if (this.selectedRecordList?.length > 0) {
          this.selectedParentAccount = ParseHelper.DeepCopy(this.selectedRecordList[0]);
          this.contactForm.patchValue({
            businessName: this.selectedParentAccount
          })

      }
      this.displayManualPopup = false;
    }

    removeParentAccount() {
      this.selectedParentAccount = null;
      this.contactForm.patchValue({
        businessName: null
      })
    }

    manualpopupCancelClicked() {
      this.displayManualPopup = false;
    }

    columnSettingSaved($event){
      this.manualRuleColumnSetttings = $event;
    }

    chooseAccountCol() {
      this.selectedModule = this.allModuleList.find(name=> name.name.toLowerCase() == this.associationTypeName?.toLowerCase());
      this.columnSettingsService.getColumnSettings(this.selectedModule?.id,this.selectedChannel?.id ?? 1).subscribe(
          resp => {
              let defaultColumnSettings: Partial<ColumnSettingsN> = ParseHelper.DeepCopy(resp);
              this.manualRuleColumnSetttings = defaultColumnSettings;
          },
          );
      }
  
    openParentAcountDialog(type){
      this.chooseAccountCol();
      if(type == 'new'){
      this.selectedRecordList =  [];
      }
      this.displayManualPopup = true;
      }

  getPhoneCode(index: number): string {
    const countryControl = this.additionalPhones.at(index).get('country')?.value;
    const selectedCountry = this.countryData?.find(country => country?.CountryName === countryControl);
    return selectedCountry ? selectedCountry.PhoneCode : '';
  }


  addSocialField(): void {
    const lenght =  this.inputDataCheck?.social?.childFields?.filter(ele=>ele.enabledInForm)?.length 
    if ((this.additionalSocialProfile?.length <= (lenght)) ) {
      if (this.socialProfiles?.length > 0) {
        const newIcon = this.getNewIconClass();
        this.socialProfiles.push(newIcon);
        this.availableIcons = this.availableIcons?.filter(icon => icon !== newIcon);
      this.additionalSocialProfile.push(this.createSocialProfileField(undefined,newIcon));
      }
    }
  }
  getNewIconClass(): string {
    return this.availableIcons?.length > 0 ? this.availableIcons[0] : 'fa-twitter'; //its not need to else condition
  }
  removeEmailField(index: number): void {
    const emailArray = this.contactForm.get('additionalEmails') as FormArray;
    const removedLabel = emailArray.at(index).value.label; 
    emailArray.removeAt(index);
    this.availableEmailLabels.push(removedLabel);
    this.availableEmailLabels.sort(); 
  }
  
  removePhoneField(index: number): void {
    const additionalPhones = this.contactForm.get('additionalPhones') as FormArray;
    const removedLabel = additionalPhones.at(index).value.name;
    additionalPhones.removeAt(index);
    if (removedLabel !== this.firstPhoneLabel) {
      this.availableFields.push(removedLabel);
    }
    this.availableFields.sort(); 
  }

  removeSocialProfileField(index: number) {
    const removedIcon = this.socialProfiles[index];
    this.additionalSocialProfile.removeAt(index);
    this.socialProfiles.splice(index, 1);
    if (removedIcon !== 'fa-twitter' && !this.availableIcons.includes(removedIcon)) {
      this.availableIcons.push(removedIcon);
    }
  }

  setupFormListeners(): void {
    this.contactForm.get('contactAssociation').valueChanges
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(value => {
        this.onContactAssociationChange(value);
      });

    this.contactForm.get('businessName').valueChanges
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(value => {
        if (typeof value === 'string') {
          this.onBusinessNameChange(value);
        }
      });
  }
  // #region Add method
  changeStatus(e) {
    this.updateStatusId = true;
    if (this.contactEditDetails?.statusId === Status.Active) {
      this.contactEditDetails.statusId = Status.InActive;
    } else if (this.contactEditDetails?.statusId === Status.InActive) {
      this.contactEditDetails.territories = this.contactEditDetails?.territories?.filter(ele=>ele?.organizationId)
      this.contactEditDetails.statusId = Status.Active;
    }
  }

  updateStatus(){
    this.sharedContactV1Service.updateContact(this.contactEditDetails).subscribe({
      next: (response) => {
        this.isSubmitted = false;
        this.onDialogHide();
        this.loadContactList.emit();
        this.refreshList.emit({});
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: `Contact ${this.mode == 'edit' ? 'updated' : 'added'} successfully`
        });
    this.appMainService.isHideSpinner('onSubmit');
      },
      error: (error) => {
        this.appMainService.isHideSpinner('onSubmit');
        this.isSubmitted =  false;
        let errorMessage = `Failed to ${this.mode == 'edit' ? 'update' : 'add'} contact. Please try again.`;
        if (error.error) {
          errorMessage = typeof(error.error.Message) == "string" ? error.error.Message :  Object.values(error.error.Message).flat().join('');
        }
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: errorMessage
        });
      }
    });
  }

  onSubmit() {    
    let operation = null
    this.isSubmitted = true;
    if (this.contactForm.valid) {
      this.appMainService.isShowSpinner('onSubmit');
      const formData = this.contactForm.getRawValue();
      const contact: Contact = this.prepareContactData(formData);
      if (this.mode == 'edit') {
        operation = this.sharedContactV1Service.updateContact(contact);
      } else {
        operation = this.sharedContactV1Service.addContact(contact);
      }
      operation.subscribe({
        next: (response) => {
          this.isSubmitted = false;
          this.onDialogHide();
          this.loadContactList.emit();
          this.refreshList.emit({});
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: `Contact ${this.mode == 'edit' ? 'updated' : 'added'} successfully`
          });
      this.appMainService.isHideSpinner('onSubmit');
        },
        error: (error) => {
          this.appMainService.isHideSpinner('onSubmit');
          this.isSubmitted =  false;
          let errorMessage = `Failed to ${this.mode == 'edit' ? 'update' : 'add'} contact. Please try again.`;
          if (error.error) {
            errorMessage = typeof(error.error.Message) == "string" ? error.error.Message :  Object.values(error.error.Message).flat().join('');
          }
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: errorMessage
          });
        }
      });
    } else {
      this.markFormGroupTouched(this.contactForm);
      const invalidFields = [];
      Object.keys(this.contactForm.controls)?.forEach(field => {
        const control = this.contactForm.get(field);
        if (control && control.invalid) {
          if (field === 'additionalEmails') {
            invalidFields.push('Email'); 
          } else if(field === 'businessName') {
            invalidFields.push('Association Name');
          }else if(field === 'firstName') {
            invalidFields.push('First Name');
          }else{
            invalidFields.push(field); 
          }
        }
      });
      if (invalidFields.length > 0) {
        this.messageService.add({
          severity: 'error',
          summary: 'Validation Error',
          detail: `Please fill the following fields correctly: ${invalidFields.join(', ')}.`
        });
      }
      this.isSubmitted =  false;
    }
  }


  populateDefaultGroup() {
    // atomatic added default value in particul array
    //annualIncome
      this.currentSelectedIncome = this.annualIncome?.find(el => el.isDefault);
      //contactTypes
      this.selectedContactType = this.contactTypes?.find(el => el.isDefault);
      //degree
      this.selectedDegree = this.degree?.find(el => el.isDefault);
      //selectedStudyField
      this.selectedStudyField = this.studyField?.find(el => el.isDefault);
      //selectedGender
      this.selectedGender = this.gender?.find(el => el.isDefault);
      //jobFunction
      this.currentSelectedContactRole = this.jobFunction?.find(el => el.isDefault);
      //source
      this.currentSelectedSource = this.source?.find(el => el.isDefault);
      //titles
      this.selectedtitles = this.titles?.find(el => el.isDefault);

      this.defaultContactRole  = this.contactRoles?.filter(el => el.isDefault);
  }


fetchInitialData(): void {
  forkJoin({
    addressTypes: this.coreHttpService.getAllAddressTypes().pipe(takeUntil(this.ngUnsubscribe)),
    addressClasses: this.coreHttpService.getAllAddressClasses().pipe(takeUntil(this.ngUnsubscribe)),
    countries: from(this.contactService.getAllCountries()) 
  })
  .subscribe(({ addressTypes, addressClasses, countries }) => {
    this.accountAddressTypes = addressTypes;
    this.addressClasses = addressClasses;
    this.countries = countries;
    
    
    this.storeService.setAddressTypes(addressTypes);
    this.storeService.setAddressClasses(addressClasses);
    this.storeService.setCountries(countries);
  });
}


handleCompleteMethod(event, type): void {
   let selectedAssistantId = this.contactForm.get('selectedAssistant')?.value?.id
   let selectedReportsToId = this.contactForm.get('selectedReportsTo')?.value?.id
  
  const searchValue = event?.query?.toLowerCase() || "";
  const requestModel: GelAllContactRequestModel = {
    associationTypeName: this.associationTypeName,
    isActive: true,
    globalSearchValue: searchValue.trim(),
    selectableColumns: [{ columnName: "firstName", isCustom: false }],
    filter: 'allcontacts',
    pageSize: 100,
    pageNumber: 1,
    sortByColumn: null,
    isSortByDescending: true,
    filterableColumns: [],
    globalChannelId: this.selectedChannel?.id,
  };

  this.contactService.getContactList(requestModel)
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe({
      next: (response) => {
        if (response && response?.list) {
          const filteredList = response?.list?.filter(item => 
            item?.firstName && item?.firstName?.toLowerCase()?.includes(searchValue)) 
          if (type === 'reportsTo') {
            this.reportsToList = this.removeDuplicates(filteredList)?.filter(ele=>ele.id !== selectedAssistantId);
          } else if (type === 'assistantTo') {
            this.assistantToList = this.removeDuplicates(filteredList)?.filter(ele=>ele.id !== selectedReportsToId);
          } else {
            this.seniorityList = this.removeDuplicates(filteredList);
          }
        }
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error!',
          detail: 'Error occurred while loading contacts. Please try again later.'
        });
        this.appMainService.isHideSpinner('getAllContactLoader');
      }
    });
}

removeDuplicates(list: any[]): any[] {
  return list?.filter((value, index, self) =>
    index === self.findIndex((t) => t.firstName === value?.firstName)
  );
}

getDynamicValidators(fieldName: string): ValidatorFn[] {
  const fieldConfig = this.templateSections[0]?.fields?.find(item => item?.field === fieldName);
  return fieldConfig?.isRequired ? [Validators.required] : []; 
}

  prepareContactData(formData: any): Contact {
    // return
    const updatedLanguages = this.updateContactSpokenLanguages(formData);
    const updateSocialProfile = this.updateSocialProfile(formData);
    const updatePhonne = this.updatePhonne(formData);
    const updateEmail = this.updateEmail(formData);

    this.appMainService.isShowSpinner('prepareContactData');
    const contact: Contact = {
      id: this.mode == 'edit' ? this.selectedContactDetails?.id : 0,
      createdSource: this.mode == 'edit' ? this.contactEditDetails?.createdSource : this.app.userIP,
      createdBy: this.mode == 'edit' ? this.contactEditDetails?.createdBy : this.app.user.userId,
      createdDate: this.mode == 'edit' ? this.contactEditDetails?.createdDate : new Date().toISOString(),
      ...(this.mode == 'edit' && {
        updatedSource: this.app.user.userIP,
        updatedBy: this.app.user.userId,
        updatedDate: new Date().toISOString()
      }),
      firstName: formData.firstName ?? '',
      middleName: formData.middleName ?? '',
      lastName: formData.lastName ?? '',
      genderId: formData.gender?.id || null,
      title: formData.title,
      sourceId: formData.source?.id || null,
      sequenceNumber: this.mode == 'edit' ? this.contactEditDetails?.sequenceNumber : formData?.sequenceNumber,
      emailAddress: formData?.emailAddress || '',
      socialProfile: formData?.socialProfile || '',
      dateOfBirth: formData.birth ? this.app._saveDateTimeWithZone(formData?.birth,true) : null,
      contactAddresses: this.transformedAddresses?.length ? this.transformedAddresses : [] ,
      startDate: formData.startDate ? this.app._saveDateTimeWithZone(formData.startDate ,true) : null,
      jobFunction: formData.jobFunction?.name || '',
      ContactRoleId: formData.jobFunction?.id || null,
      department: formData.department || '',
      seniority: formData.seniority?.firstName ||  this.contactEditDetails?.seniority ||'',
      description: formData.description || '',
      assPhoneCode : formData.assPhoneCode || '', 
      assistantPhone: formData.assistantPhone || '',
      relationshipStatusId: formData.relation?.id || null,
      maritalStatusId: formData.marital?.id || null,
      annualIncomeId: formData.income?.id || null,
      degreeId: formData.degree?.id || null,
      contactSpokenLanguagesId: formData.language?.id || null,
      contactSpokenLanguages : updatedLanguages || [],
      fieldOfStudyId: formData.studyField?.id || null,
      contactTypeId: formData?.contactType || this.selectedContactType?.value || this.contactTypes[0]?.value || null,
      associationId: formData.businessName?.id || this.filteredBusinessNames[0]?.associationId || this.app.user.organizationId || null,
      associationName: formData.businessName?.businessName ||formData.businessName?.name || this.filteredBusinessNames[0]?.associationId || this.app.user.organizationName || '',
      assistantId: formData.selectedAssistant?.id ||  null,
      reportsToId: formData.selectedReportsTo?.id ||  null,
      contactAssociationTypeId: formData.contactAssociation?.id || null,
      isPrimaryContact : this.mode == 'add' ?  false : this.contactEditDetails?.isPrimaryContact,
      email: formData?.primaryEmail,
      contactPhones: updatePhonne || [],
      contactSocialProfiles:updateSocialProfile || [],
      contactProfileImages: [],
      territories: null,
      statusId: formData.isActive ? 1 : 2,
      contactRoles: this.formatContactRoleEdit(formData.contactRoles),
      organizationId: this.app.companyId,
      salutationId: formData.title,
      country: formData.country,
      contactEmails: updateEmail || [],
    };

  this.contactProfileImages?.forEach((img: any, index: number) => {
    if(this.contactProfileImages[index]?.attachment){
      contact.contactProfileImages.push({
      contactId: img.contactId ?? 0,
      attachmentId: img.attachmentId ?? 0,
      attachment: this.contactProfileImages[index].attachment,
      id: img.id ?? 0,
      createdSource: this.app.userIP,
      createdBy: this.app.user.userId,
      createdDate: new Date().toISOString(),
      ...(img?.contactId && {
        updatedSource: this.app.user.userIP,
        updatedBy: this.app.user.userId,
        updatedDate: new Date().toISOString()
      }),
    });
   }
  });
  this.appMainService.isHideSpinner('prepareContactData');
    return contact;
  }
  
  updateContactSpokenLanguages(formData) {
    if (!this.contactEditDetails) {
      this.contactEditDetails = {};
    }
    if (!this.contactEditDetails?.contactSpokenLanguages) {
      this.contactEditDetails.contactSpokenLanguages = [];
    }
    const updateIds = new Set(formData?.language.map(item => item.id));
    this.contactEditDetails?.contactSpokenLanguages.forEach(item => {
      if (!updateIds.has(item?.languageId)) {
        item.statusId = 3;
      }
    });
    formData?.language.forEach(newItem => {
      const exists = this.contactEditDetails?.contactSpokenLanguages?.some(item => item?.languageId === newItem?.id);
      if (!exists) {
        this.contactEditDetails?.contactSpokenLanguages.push({
          contactId: this.contactEditDetails?.contactSpokenLanguages[0]?.contactId,
          languageId: newItem.id,
          language: {
            id: newItem?.id,
            name: newItem.name,
            createdBy: this.app.user.userId,
            createdSource: this.app.userIP,
            statusId: 1
          },
          statusId: 1,
            updatedSource: this.app.user.userIP,
            updatedBy: this.app.user.userId,
            updatedDate: new Date().toISOString()
        });
      }
    });
    return this.contactEditDetails.contactSpokenLanguages;
  }
  updatePhonne(formData) {
    if (!this.contactEditDetails) {
      this.contactEditDetails = {};
    }
    if (!this.contactEditDetails?.contactPhones) {
      this.contactEditDetails.contactPhones = [];
    }
    const updateIds = new Set(formData?.additionalPhones.map(item => item?.contactData?.id));
    this.contactEditDetails?.contactPhones?.forEach(item => {
      if (!updateIds.has(item?.id)) {
        item.phone.statusId = 3; 
      }
    });
    formData.additionalPhones?.forEach(phone => {
      if (!phone) return; 
      const existingProfile = this.contactEditDetails?.contactPhones?.find(
        item => item?.id === phone?.contactData?.id
      );
      if (existingProfile) {
        if (!phone) return; 
        existingProfile.updatedSource = this.app.user.userIP;
        existingProfile.updatedBy = this.app.user.userId;
        existingProfile.updatedDate = new Date().toISOString();
        existingProfile.phone = {
          ...existingProfile.phone, 
          number: phone?.number ? `${phone?.country?.PhoneCode ?? ''}${phone.number}` : '', 
          country: phone?.country?.CountryName || '', 
          code: phone?.country?.PhoneCode || '', 
        };
      } else {
        // if (!phone) return; 
        this.contactEditDetails?.contactPhones.push({
          id: phone?.contactData?.id ?? 0,
          createdSource: phone?.contactData?.createdSource ?? this.app.userIP,
          createdBy: phone?.contactData?.createdBy ?? this.app.user.userId,
          createdDate: phone?.contactData?.createdDate ?? new Date().toISOString(),
          ...(phone?.contactData?.id && {
            updatedSource: this.app.user.userIP,
            updatedBy: this.app.user.userId,
            updatedDate: new Date().toISOString()
          }),
          contactId: formData?.additionalPhones[0]?.contactData?.contactId ?? 0,
          phoneId: phone?.contactData?.phoneId ?? 0,
          phone: {
            id: phone?.contactData?.phone?.id ?? 0,
            createdSource: phone?.contactData?.phone?.createdSource ?? this.app.userIP,
            createdBy: phone?.contactData?.phone?.createdBy ?? this.app.user.userId,
            createdDate: phone?.contactData?.phone?.createdDate ?? new Date().toISOString(),
            ...(phone?.contactData?.phone?.id && {
              updatedSource: this.app.user.userIP,
              updatedBy: this.app.user.userId,
              updatedDate: new Date().toISOString()
            }),
            number: phone?.number ? `${phone?.country?.PhoneCode ?? ''}${phone.number}` : '',
            country: phone?.country?.CountryName || '',
            code: phone?.country?.PhoneCode || '',
            extension: '',
            description: '',
            phoneTypeId: phone?.contactData?.phone?.phoneTypeId ?? this.getDefaultphoneTypeId(phone?.name),
            statusId: 1
          }
        })
      }
    });
    return this.contactEditDetails.contactPhones;
  }
  updateSocialProfile(formData) {
    if (!this.contactEditDetails) {
      this.contactEditDetails = {};
    }
    if (!this.contactEditDetails?.contactSocialProfiles) {
      this.contactEditDetails.contactSocialProfiles = [];
    }
    const updateIds = new Set(formData?.additionalSocialProfile.map(item => item?.profileData?.id));
    this.contactEditDetails?.contactSocialProfiles?.forEach(item => {
      if (!updateIds.has(item?.id)) {
        item.socialProfile.statusId = 3; 
      }
    });
    formData.additionalSocialProfile?.forEach(social => {
      if (!social) return; 
      const existingProfile = this.contactEditDetails?.contactSocialProfiles?.find(
        item => item?.socialProfileId === social?.profileData?.id
      );
      if (existingProfile) {
        if (!social.socialProfile) return; 
        existingProfile.updatedSource = this.app.user.userIP;
        existingProfile.updatedBy = this.app.user.userId;
        existingProfile.updatedDate = new Date().toISOString();
        existingProfile.socialProfile = {
          ...existingProfile.socialProfile, 
          name: social.socialProfile || '',      
      };
      } else {
        // if (!social?.socialProfile) return; 
        this.contactEditDetails?.contactSocialProfiles.push({
          id: social?.profileData?.id ?? 0,
          createdSource: social?.profileData?.createdSource ?? this.app.userIP,
          createdBy: social?.profileData?.createdBy ?? this.app.user.userId,
          createdDate: social?.profileData?.createdDate ?? new Date().toISOString(),
          ...(social?.profileData?.id && {
            updatedSource: this.app.user.userIP,
            updatedBy: this.app.user.userId,
            updatedDate: new Date().toISOString()
          }),
          contactId: formData.additionalSocialProfile[0]?.profileData?.contactId ?? 0,
          socialProfileId: social?.profileData?.socialProfileId ?? 0,
          socialProfile: {
            id: social?.profileData?.socialProfile?.id ?? 0,
            socialProfileTypeId: social?.profileData?.socialProfile?.socialProfileTypeId ?? this.getDefaultSocialProfileTypeId(typeof(social?.profileData) === 'string' ? social?.profileData?.slice(3) : 'twitter'),
            statusId: 1,
            description: '',
            name: social.socialProfile || ".",
            createdSource: social?.profileData?.socialProfile?.createdSource ?? this.app.userIP,
            createdBy: social?.profileData?.socialProfile?.createdBy ?? this.app.user.userId,
            createdDate: social?.profileData?.socialProfile?.createdDate ?? new Date().toISOString(),
            ...(social?.profileData?.id && {
              updatedSource: this.app.user.userIP,
              updatedBy: this.app.user.userId,
              updatedDate: new Date().toISOString()
            }),
          }
        });
      }
    });
    return this.contactEditDetails.contactSocialProfiles;
  }
  updateEmail(formData) {
    if (!this.contactEditDetails) {
      this.contactEditDetails = {};
    }
    if (!this.contactEditDetails?.contactEmails) {
      this.contactEditDetails.contactEmails = [];
    }
    const updateIds = new Set(formData?.additionalEmails.map(item => item?.emailData?.id));
    this.contactEditDetails?.contactEmails?.forEach(item => {
      if (!updateIds.has(item?.id)) {
        item.email.statusId = 3; 
      }
    });
    formData.additionalEmails?.forEach(email => {
      if (!email) return; 
      const existingProfile = this.contactEditDetails?.contactEmails?.find(
        item => item?.id === email?.emailData?.id
      );
      if (existingProfile) {
        // if (!social.socialProfile) return; 
        existingProfile.updatedSource = this.app.user.userIP;
        existingProfile.updatedBy = this.app.user.userId;
        existingProfile.updatedDate = new Date().toISOString();
        existingProfile.email = {
          ...existingProfile.email, 
          emailAddress: email.emailAddress|| '',      
      };
      } else {
        // if (!social?.socialProfile) return; 
        this.contactEditDetails?.contactEmails.push({
          id: email?.emailData?.id ?? 0,
          createdSource: email?.emailData?.createdSource ?? this.app.userIP,
          createdBy: email?.emailData?.createdBy ?? this.app.user.userId,
          createdDate: email?.emailData?.createdDate ?? new Date().toISOString(),
          ...(email?.emailData?.id && {
            updatedSource: this.app.user.userIP,
            updatedBy: this.app.user.userId,
            updatedDate: new Date().toISOString()
          }),
          contactId: formData.additionalEmails[0]?.emailData?.contactId ?? 0,
          emailId: email?.emailData?.emailId ?? 0,
          email: {
            id: email?.emailData?.email?.id ?? 0,
            createdSource: email?.emailData?.email?.createdSource ?? this.app.userIP,
            createdBy: email?.emailData?.email?.createdBy ?? this.app.user.userId,
            createdDate: email?.emailData?.email?.createdDate ?? new Date().toISOString(),
            ...(email?.emailData?.email?.id && {
              updatedSource: this.app.user.userIP,
              updatedBy: this.app.user.userId,
              updatedDate: new Date().toISOString()
            }),
            emailAddress: email?.emailAddress || '',
            description: '',
            emailTypeId: email?.emailData?.email?.emailTypeId ?? this.getDefaultEmailTypeId(email?.label),
            statusId: 1
          },
        });
      }
    });
    return this.contactEditDetails.contactEmails;
  }
  getDefaultEmailTypeId(str: string): number {
    switch (str) {
      case 'Work Email': return EMAIL_TYPE_IDS.WORK;
      case 'Home Email': return EMAIL_TYPE_IDS.HOME;
      case 'CE1': return EMAIL_TYPE_IDS.CE1;
      case 'CE2': return EMAIL_TYPE_IDS.CE2;
      default: return EMAIL_TYPE_IDS.WORK;
    }
  }

  getDefaultSocialProfileTypeId(str: string): number {
    switch (str) {
      case 'twitter': return SOCIAL_PROFILE_TYPE_IDS.TWITTER;//TWITTER
      case 'facebook': return SOCIAL_PROFILE_TYPE_IDS.FACEBOOK;//FACEBOOK
      case 'linkedin': return SOCIAL_PROFILE_TYPE_IDS.LINKEDIN;//LINKEDIN
      case 'instagram': return SOCIAL_PROFILE_TYPE_IDS.INSTAGRAM;//INSTAGRAM  
      default: return SOCIAL_PROFILE_TYPE_IDS.WEBSITE;//website
    }
  }

  getDefaultphoneTypeId(str: string): number {
    switch (str) {
      case 'Work Phone': return PHONE_TYPE_IDS.WORK;
      case 'Home Phone': return PHONE_TYPE_IDS.HOME;
      case 'Mobile Phone': return PHONE_TYPE_IDS.MOBILE;
      case 'CP1': return PHONE_TYPE_IDS.CP1;
      default: return PHONE_TYPE_IDS.CP2;
    }
  }
  // Helper method to get form validation errors
  getFormValidationErrors() {
    const errors = [];
    Object.keys(this.contactForm.controls)?.forEach(key => {
      const controlErrors = this.contactForm.get(key).errors;
      if (controlErrors != null) {
        Object.keys(controlErrors)?.forEach(keyError => {
          errors.push({
            control: key,
            error: keyError,
            value: controlErrors[keyError]
          });
        });
      }
    });
    return errors;
  }

  markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls)?.forEach(control => {
      control.markAsTouched();

      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  toggleShowMore(): void {
    this.showMore = !this.showMore;
  }

  // #region getTemplateFeidls
  getTemplateFormFields() {
    this.appMainService.isShowSpinner('getTemplateFormFields');
    this.sharedConfigService.getTemplateFormFields(this.contactModuleId, 1)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (response) => {
          this.templateSections = response || [];
          this.labels_addition = this.templateSections?.find(ele=>ele?.name == 'Contact Additional');
           this.labels_address = this.templateSections?.find(ele=>ele?.name == 'Contact Address')?.fields?.map(item => {
            return {
              ...item,
              ischecked: item.enabledInForm,
              labelname: item.name,
              checked :   item.enabledInForm      
            };
          });
          this.labels_address = this.labels_address?.filter(ele=>ele?.name !== 'Address Type' && ele?.name !== 'Address Class') 
          this.generateCheckFields();
          this.fetchInitialData();
          this.noTemplateMessage = '';
        },
        error: (() => {

          this.templateSections = [];
          this.noTemplateMessage = 'Error loading template under this channel.';
        }),
        complete: (() => {
          this.appMainService.isHideSpinner('getTemplateFormFields');
        })
      });
  }

  generateCheckFields() {
    // dynamic add check and labelName
    this.inputDataCheck = this.templateSections[0]?.fields?.reduce((acc, item) => {
      acc[item.field] = {
        ...item 
      };
      return acc;
  }, {});
  this.availableFields = this.inputDataCheck?.phone?.childFields?.filter(field => field.enabledInForm)?.map(field => field.name) || [];
  
  this.availableEmailLabels = this.inputDataCheck?.email?.childFields?.filter(field => field.enabledInForm).map(field => field.name) || [];
  this.availableIcons = this.inputDataCheck?.social?.childFields
  ?.filter(field =>  field.enabledInForm)
  .map(field => {
    if (field.name === 'Website') {
      return 'fa-laptop';
    }
    return `fa-${field.name.toLowerCase()}`;
  }) || [];
  // To display the default label for phone, social profile, and email at index 0 and ensure it doesn't appear in the
  //  selectable options, we remove it from the original array using the slice() method.
  if(this.mode =='add'){
  this.socialProfiles.push(this.availableIcons[0]);
  this.availableIcons = this.availableIcons.slice(1);
  this.firstEmailLabel = this.availableEmailLabels[0];
  this.availableEmailLabels = this.availableEmailLabels.slice(1);
  this.firstPhoneLabel = this.availableFields[0];
  this.availableFields = this.availableFields.slice(1);
  }
  this.initForm();
  }
  onDialogHide(): void {
    this.displayContactAddEditChange.emit(false);
  }

  onCountrySelect(event: any, phone: any) {
    const selectedCountry = this.countryData?.find(item => item.CountryName === event.value);
    if (selectedCountry) {
      phone.phone.code = selectedCountry.PhoneCode;
    }
  }

  getCountryData() {
    this.accountUserService.countryCode().pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (response) => {
          this.countryData = response;
        },
        error: (error) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error?.error?.message || 'Failed to load country data. Please try again.'
          });
        }
      });
  }

  getContactTypes(response) {
    this.contactTypes = response?.map(type => ({
      name: type.name,
      value: type.id,
      isDefault: type.isDefault
    }));
  }


  // image section
  onUpload(files: File[]) {
    if (typeof Worker !== undefined) {
      for (let file of files) {
        let errors = validateFiles(file, 4, this.allowedExtensions);
        if (errors?.length > 0) {
          for (let error of errors) {
            this.messageService.add({
              severity: "error",
              summary: "Error",
              detail: error.fileName + ": " + error.error,
            });
          }
        } else {
          uploadFiles(file, ({ name, content, size, extension }) => {
            let attachment = {
              id: 0,
              createdSource: this.app.user.userIP,
              updatedSource: this.app.user.userIP,
              createdBy: this.app.user.userId,
              updatedBy: this.app.user.userId,
              createdDate: new Date().toISOString(),
              updatedDate: new Date().toISOString(),
              name: name,
              guidName: "",
              location: "",
              content: content,
              extension: extension,
              sizeInBytes: size,
              mediaType: "",
              description: "",
              statusId: Status.Active,
              isValid: true,
              validFromDate: new Date().toISOString(),
              validToDate: this.addYearPipe.transform(new Date()),
            };
            this.contactProfileImages.push({attachment : attachment});

          });
        }
      }
    } else {
      this.messageService.add({
        severity: "error",
        summary: "Error",
        detail: "Please update the browser. Web Workers are not supported in the older versions of this browser.",
      });
    }
    this.app.copyObjectWithoutRefrence(this.contactProfileImages)
  }

  removeImage(files: File) {
    this.contactProfileImages.forEach(element => {
      if (element?.attachment?.name == files?.name) {
        const index = this.contactProfileImages.indexOf(element);
        this.contactProfileImages.splice(index, 1);
      }
    });
  }

  downloadFile(filePath) {
    window.open(filePath);
  }

  deleteImage(imageId) {
    this.contactProfileImages.forEach(element => {
      if (element.id == imageId) {
        element.attachment.statusId = 3 
      }
    });

  }

  searchVendor(accountName: string = ""): any {
    const requestModel: GelAllAccountRequestModel = {
      channelId: 1,
      stageId: null,
      isActive: true,
      globalSearchValue: accountName,
      selectableColumns: [{
        columnName: "businessName",
        isCustom: false
      }],
      filter: null,
      pageSize: 15,
      pageNumber: 1,
      sortByColumn: null,
      isSortByDescending: true,
      filterInColumns: []
    };
    this.appMainService.isShowSpinner('getAccountList');
    this.accountServiceN.getVendorNames(requestModel)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (response) => {
          if (response) {
            this.filteredBusinessNames = response;
            if(this.businessName && this.filteredBusinessNames){
            this.contactForm.patchValue({
              businessName: { id: this.filteredBusinessNames[0]?.id, name:this.filteredBusinessNames[0]?.name },
            });
            this.contactForm.get('businessName').disable();
          }
          }
          this.appMainService.isHideSpinner('getAccountList');
        },
        error: (error) => {
        }
      });
  }


  onContactAssociationChange(selectedAssociation: any): void {
    if (selectedAssociation) {
      this.contactForm.get('businessName').reset();
      this.filteredBusinessNames = [];
    }
  }
  changeAssociation(event){
    const data = event?.value
    if(data?.name == 'Organization'){
      this.contactForm.patchValue({
        businessName: { id: this.app.user.organizationId, name:this.app.user.organizationName },
      });
      this.contactForm.get('businessName').disable();
    }else if(data?.name == 'Lead'){
      this.contactForm.get('businessName').enable();
      this.contactForm.patchValue({
        businessName: '',
      });
    }
  }
  onBusinessNameChange(inputValue: string): void {
    const selectedAssociation = this.contactForm.get('contactAssociation').value;
    if (selectedAssociation && inputValue) {
      if (selectedAssociation.id === VENDOR_ID) {
        this.searchVendor(inputValue);
      }else{
        this.contactForm.patchValue({
          businessName: { id: this.contactAssociations?.find(item => item.name == "Organization")?.id, name:this.app.user.organizationName },
        });
      }
    } else {
      this.filteredBusinessNames = [];
    }
  }


  onCountryChange(event: any, index: number): void {
    const selectedCountry = event.value;
    const countryCode = this.countryData.find(country => country.CountryName === selectedCountry.CountryName)?.PhoneCode || '';
    const additionalPhonesFormArray = this.contactForm.get('additionalPhones') as FormArray;
    const phoneFormGroup = additionalPhonesFormArray.at(index);
    if (phoneFormGroup) {
      phoneFormGroup.patchValue({ phoneCode: countryCode });
    }
  }

  onAsstPhoneCodeChange(event: any): void {
    const countryCode = this.countryData?.find(country => country.PhoneCode === (event.value?.PhoneCode || ''));
    if (countryCode) {
      this.contactForm.controls.assPhoneCode.patchValue(countryCode?.PhoneCode);
    }
  }

  //#region Address
  prepareAccountFormDataForCopy() {

    if (this.contactTempAddress?.length > 0) {
      this.onUpdateAddressList({ addressList: this.contactTempAddress });
    }
  }


  loadAddressClasses(): void {
    this.sharedDataService
      .loadAddressClasses()
      .pipe(
        map((addressClasses) => {
          this.addressClasses =
            addressClasses?.filter((el) => el.isActive) || [];
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  loadAddressTypes(): void {
    this.sharedDataService
      .loadAddressTypes()
      .pipe(
        map((addressTypes) => {
          this.addressTypes = addressTypes?.filter((el) => el.isActive) || [];
        }),
        catchError(() => [])
      )
      .subscribe();
  }


  //#region ShowEditDetails

  populateContactEditDetails(selectedContact: any): void {

    this.appMainService.isShowSpinner('getContactDetails');
    const associationTypeId = this.contactAssociations?.find(title => title.name?.toLowerCase() === this.associationTypeName?.toLowerCase())
    this.sharedContactV1Service.getContactDetailsById(selectedContact?.id, associationTypeId?.id)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (response) => {
          this.contactEditDetails = response;
          this.contactTempAddress = response?.contactAddresses;
          this.patchFormWithContactDetails(this.contactEditDetails);
          this.prepareAccountFormDataForCopy();
          this.appMainService.isHideSpinner('getContactDetails');
        },
        error: (error) => {
          console.error('Error fetching contact details:', error);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to load contact details. Please try again.'
          });
          this.appMainService.isHideSpinner('getContactDetails');
        }
      });
  }
  createPhoneGroup(contactPhone: any = {}): FormGroup {
    return this.fb.group({
      country: [contactPhone?.phone?.country || this.getCountryName(this.app.userDetails?.locations?.[0]?.address?.country?.name || this.app.organizationData?.address?.country?.name) || '', [...this.getDynamicValidators('phone')]],
      number: [contactPhone?.phone?.number || '', [...this.getDynamicValidators('phone')]],
      contactData: [contactPhone],
      name: contactPhone?.phone?.phoneType?.name || this.firstPhoneLabel,
      phoneCode :[contactPhone?.phone?.code || this.app.userDetails?.locations?.[0]?.address?.country?.phoneCode || this.app.organizationData?.address?.country?.phoneCode]
    });
  }

  patchFormWithContactDetails(details: any): void {
    const selectedCountry = this.countryData?.find(country =>
      country?.CountryName === details?.contactPhones?.[0]?.phone?.country
    );
    const selectedAsstCountry = this.countryData?.find(country =>
      country?.PhoneCode === details?.assPhoneCode
    );

    this.mainSelectedCountry = selectedCountry;
    this.phoneCountryCodes = [];
    details?.contactPhones?.forEach((contactPhone: any, index: number) => {

      if (contactPhone?.phone?.country && contactPhone?.phone?.code) {
        this.phoneCountryCodes.push({
          CountryName: contactPhone?.phone?.country,
          PhoneCode: contactPhone?.phone?.code,
          number: contactPhone?.phone?.number
        });
      }
    });
  if(details){
    this.contactForm.patchValue({
      id: details.id,
      firstName: details?.firstName ?? "",
      middleName: details?.middleName ?? "",
      lastName: details?.lastName ?? "",
      contactType: details?.contactTypeId,
      emailAddress: details?.contactEmails?.[0]?.email?.emailAddress,
      contactAssociation: this.findContactAssociation(details?.contactAssociationTypeId),
      businessName: { id: details?.associationId, name: details?.associationName },
      title: details?.salutationId,
      email: details?.email,
      country: selectedCountry,
      phoneNumber: details?.contactPhones?.[0]?.phone?.number,
      gender: this.findGender(details.genderId),
      department: details?.department,
      seniority: details?.seniority ,
      description: details?.description,
      assistantPhone: details?.assistantPhone,
      assCountry: details?.assistantPhone ? selectedAsstCountry : this.getCountryName(this.app.userDetails?.locations?.[0]?.address?.country?.name || this.app.organizationData?.address?.country?.name),
      assPhoneCode: details?.assistantPhone ? details?.assPhoneCode : (this.app.userDetails?.locations?.[0]?.address?.country?.phoneCode || this.app.organizationData?.address?.country?.phoneCode),
      selectedAssistant :details?.assistant,
      selectedReportsTo : details.reportsTo ,
      birth: details?.dateOfBirth ? this.app._showDateTimeWithZone(details?.dateOfBirth) : null,
      startDate: details?.startDate ? this.app._showDateTimeWithZone(details?.startDate)  : null,
      jobFunction: this.findJobFunction(details?.contactRoleId),
      contactRoles: details?.contactRoles ?? null,
      relation: this.findRelation(details?.relationshipStatusId),
      marital: this.findMarital(details?.maritalStatusId),
      source: this.findSource(details?.sourceId),
      income: this.findIncome(details?.annualIncomeId),
      degree: this.findDegree(details?.degreeId),
      studyField: this.findStudyField(details?.fieldOfStudyId),
      isActive: details?.statusId === 1,
      contactProfileImages: details?.contactProfileImages,
    });
  }
    this.contactProfileImages = details?.contactProfileImages
    this.patchAdditionalPhones(details?.contactPhones);
    this.patchFormWithContactEmails(details);
    this.patchFormWithContactSocialProfiles(details);
    const isAccountOrLead = this.associationTypeName === 'account' || this.associationTypeName === 'lead';
    if (isAccountOrLead && (this.mode === 'edit' || this.mode === 'view')) {
      this.contactForm.patchValue({
        businessName: { businessName: details?.associationName, id: details?.associationId }
      });
      this.isAssociationName = true;
      if (this.mode === 'view') {
        this.contactForm.disable();
        if (this.contactEditDetails?.statusId === Status.InActive) {
          this.contactForm.get('isActive')?.enable();
        }
      }
    } else if (this.associationTypeName === 'vendor' && this.mode === 'view') {
      this.contactForm.disable();
      if (this.contactEditDetails?.statusId === Status.InActive) {
        this.contactForm.get('isActive')?.enable();
      }
    }
    this.contactForm.get('businessName').disable();

  this.patchContactSpokenLanguages(details)
  }
  
  patchContactSpokenLanguages(details){
    const array = [];
    details?.contactSpokenLanguages?.forEach((element) => {
        const filter = this.langauge?.filter(
            (cat) => cat.id == element?.language?.id
        );
        if (filter?.length > 0) {
            array.push(filter[0]);
        }
    });
    this.contactForm.controls["language"].setValue(array);
  }

  patchAdditionalPhones(contactPhones: any[]): void {
    const additionalPhonesFormArray = this.contactForm.get('additionalPhones') as FormArray;
    additionalPhonesFormArray.clear();
    if (!contactPhones?.length) {
      this.firstPhoneLabel = this.availableFields[0];
      additionalPhonesFormArray.push(this.createPhoneField(this.firstPhoneLabel));
      this.availableFields = this.availableFields.slice(1);
      return;
    }
    const check =  this.inputDataCheck?.phone?.childFields?.map(ele=>ele.name)
    const getPhoneList = contactPhones?.map(ele=>ele?.phone?.phoneType?.description)
    this.availableFields = check?.filter(field => !getPhoneList?.includes(field));
    contactPhones?.forEach((contactPhone: any) => {
      const phoneTypeName = contactPhone?.phone?.phoneType?.description;
      if (check.includes(phoneTypeName)) {
      const phoneGroup = this.createPhoneGroup(contactPhone);
      const country = this.countryData?.find((country) => country.CountryName === contactPhone?.phone?.country);
      if (country) {
        phoneGroup.patchValue({
          country: country,
          name: contactPhone?.phone?.phoneType?.description || this.firstPhoneLabel
        });
      } else {
        phoneGroup.patchValue({
          country: null
        });
      }
      additionalPhonesFormArray.push(phoneGroup);
    }
    });
  }


  patchFormWithContactSocialProfiles(details: any): void {
    const additionalSocialProfilesArray = this.contactForm.get('additionalSocialProfile') as FormArray;
    additionalSocialProfilesArray.clear();
    const check =  this.inputDataCheck?.social?.childFields?.map(ele=>ele.name)
    details?.contactSocialProfiles?.forEach((socialProfile: any) => {
      const socialTypeName = socialProfile?.socialProfile?.socialProfileType?.name;
      if (check.includes(socialTypeName)) {
      const socialProfileGroup = this.createSocialProfileField(socialProfile);
      additionalSocialProfilesArray.push(socialProfileGroup);
      }
    });
    if (additionalSocialProfilesArray?.length === 0) {
      additionalSocialProfilesArray.push(this.createSocialProfileField({}));
    }
    this.socialProfiles = [];
  this.socialProfiles = this.additionalSocialProfile.controls.map(ele => {
    const profileType = ele?.value?.profileData?.socialProfile?.socialProfileType?.name;
    let iconClass = profileType?.toLowerCase();
    if (profileType === 'Website') {
      iconClass = 'laptop'; 
    }
    return iconClass ? `fa-${iconClass}` : 'fa-twitter';
  });
  this.availableIcons = this.availableIcons.filter(icon => !this.socialProfiles.includes(icon));

  }
  patchFormWithContactEmails(response: any): void {
    const emailArray = this.contactForm.get('additionalEmails') as FormArray;
    emailArray.clear();
    const usedLabels =  this.inputDataCheck?.email?.childFields?.map(ele=>ele.name) 
    const getEmailList = response?.contactEmails?.map(ele=>ele?.email?.emailType?.name)
    this.availableEmailLabels = usedLabels.filter(field => !getEmailList.includes(field));
    response?.contactEmails?.forEach(contactEmail => {
      const emailTypeName = contactEmail?.email?.emailType?.name;
      if (usedLabels.includes(emailTypeName)) {
      const emailGroup = this.fb.group({
        emailAddress: [contactEmail?.email?.emailAddress, [...this.getDynamicValidators('email') , Validators.pattern('[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$')]],
        emailData: [contactEmail],
        label: [contactEmail?.email?.emailType?.name] 
      });
      emailArray.push(emailGroup);
    }
    });


    if (!emailArray?.length) {
      this.firstEmailLabel = this.availableEmailLabels[0];
      this.availableEmailLabels = this.availableEmailLabels.slice(1);
      emailArray.push(this.createEmailField(undefined,this.firstEmailLabel));
    }
  }

  findContactAssociation(id: number): any {
    return this.contactAssociations?.find(ca => ca.id === id) || null;
  }

  findGender(id: number): any {
    return this.gender?.find(g => g.id === id) || null;
  }

  findLanguage(id: number): any {
    return this.langauge?.find(l => l.id === id) || null;
  }

  findJobFunction(id: number): any {
    return this.jobFunction?.find(jf => jf.id == id) || null;
  }

  findRelation(id: number): any {
    return this.relation?.find(r => r.id === id) || null;
  }

  findMarital(id: number): any {
    return this.marital?.find(m => m.id === id) || null;
  }

  findSource(id: number): any {
    return this.source?.find(s => s.id === id) || null;
  }

  findIncome(id: number): any {
    return this.annualIncome?.find(i => i.id === id) || null;
  }

  findDegree(id: number): any {
    return this.degree?.find(d => d.id === id) || null;
  }

  findStudyField(id: number): any {
    return this.studyField?.find(sf => sf.id === id) || null;
  }

  getEmailErrors(emailControl: AbstractControl | null): string | null {
    if (emailControl?.errors) {
      if (emailControl.errors['required']) {
        return 'Email is required.';
      } else if (emailControl.errors['email']) {
        return 'Enter a valid email address.';
      } else if (emailControl.errors['pattern']) {
        return 'Email format is invalid. Follow the correct pattern.';
      }
    }
    return null;
  }

  onUpdateAddressList($event) {
    this.addressList = $event.addressList;
    this.addressList?.sort(this.compare);
    this.transformedAddresses = this.addressList.map(element => {
      const addressCopy = { ...element?.address };
      if (addressCopy?.country) {
        if (addressCopy.country.statusId === undefined) {
          addressCopy.country.statusId = 1;
        }
      }
      return {
        id: element.id,
        address: addressCopy,
        contactId: element?.contactId ? element?.contactId : 0,
        addressId: element?.addressId ? element?.addressId : 0,
        createdBy: element?.createdBy,
        createdDate: element?.createdDate,
        createdSource: element?.createdSource,
      };
    });
    
  }

  compare(a, b) {
    if (a.address.name < b.address.name) {
      return -1;
    }

    if (a.address.name > b.address.name) {
      return 1;
    }

    return 0;
  }

  //#region Sequence Number
  generateSequenceNumber() {
    this.configurationService
      .generateSequenceNumberByModuleId(ContactModuleId)
      .subscribe((response) => {
        this.generateSequenceSeriesNumber = response;
        this.contactForm
          .get('sequenceNumber')
          .setValue(this.generateSequenceSeriesNumber);

      });
  }

  formatContactRoleEdit(contactRoles: any[]): any[] {
    if (this.mode === 'edit' && contactRoles?.length > 0) {
      const newContactRolesArray = [];
      // Process each selected role
      contactRoles.forEach(selectedRole => {
        const existingRole = this.contactEditDetails?.contactRoles?.find(
          existing => existing?.roleId === selectedRole?.roleId
        );
  
        if (existingRole) {
          // Use existing object from backend
          newContactRolesArray.push(existingRole);
        } else {
          // Add new role object
          newContactRolesArray.push({
            contactId: this.contactEditDetails?.id,
            roleId: selectedRole?.roleId,
            statusId: 1,
            roleName: selectedRole?.roleName,
            id: 0,
            createdSource: this.app.userIP,
            updatedSource: null,
            createdBy: this.app.user.userId,
            updatedBy: null,
            createdDate: new Date(),
            updatedDate: null
          });
        }
      });
  
      // Mark previously assigned but now unselected roles
      this.contactEditDetails.contactRoles.forEach(existingRole => {
        const isStillSelected = contactRoles.some(
          selectedRole => selectedRole?.roleId === existingRole?.roleId
        );
  
        if (!isStillSelected) {
          const unselectedRole = {
            ...existingRole,
            statusId: 3,
            updatedBy: this.app.user.userId,
            updatedDate: new Date(),
            updatedSource: this.app.userIP
          };
          newContactRolesArray.push(unselectedRole);
        }
      });
  
      return newContactRolesArray;
    }
  
    // If not in edit mode or no roles selected, return original array
    return contactRoles;
  }
  

  ngOnDestroy() {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

}
